import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    treeDialogVisible;
    type;
    deviceName;
    deviceMsg;
    eidtChange;
    formData = {
        value: ''
    };
    onChange(deviceName) {
        this.formData.value = deviceName;
    }
    // formData rules
    get rules() {
        return {
            value: [
                { required: true, message: `${this.$t('inputGroupRule')}`, trigger: 'blur' },
            ]
        };
    }
    handleClose() {
        this.$emit('update:treeDialogVisible', false);
        this.$refs.deviceForm.resetFields();
    }
    submitClose() {
        this.eidtChange(this.formData.value);
        this.$emit('update:treeDialogVisible', false);
        this.$refs.deviceForm.resetFields();
    }
    submit() {
        const form = this.$refs.deviceForm;
        form.validate((valid) => {
            if (valid) {
                this.submitClose();
            }
        });
    }
    deleteDevice() {
        let delectStr = '';
        let confirm = `${this.$t('common.confirm')}`;
        if (this.deviceMsg.deviceCount === 0) {
            delectStr = `${this.$t('deleteNoMsg')}`;
        }
        else {
            delectStr = `${this.$t('deleteMsg')}`;
        }
        this.$elconfirm(delectStr, {
            type: 'warning',
            cancelButtonText: `${this.$t('common.no')}`,
            confirmButtonText: confirm,
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            callback: (action) => {
                if (action === 'confirm') {
                    this.eidtChange(this.formData.value, 'delete');
                    this.$emit('update:treeDialogVisible', false);
                    this.$refs.deviceForm.resetFields();
                }
            },
        });
    }
};
__decorate([
    Prop()
], default_1.prototype, "treeDialogVisible", void 0);
__decorate([
    Prop()
], default_1.prototype, "type", void 0);
__decorate([
    Prop()
], default_1.prototype, "deviceName", void 0);
__decorate([
    Prop()
], default_1.prototype, "deviceMsg", void 0);
__decorate([
    Prop()
], default_1.prototype, "eidtChange", void 0);
__decorate([
    Watch('deviceName', { immediate: true })
], default_1.prototype, "onChange", null);
default_1 = __decorate([
    Component({
        name: 'model',
        components: {},
        i18n: {
            messages: {
                en: {
                    editNewDevice: "Edit device group",
                    createNewDevice: "Create device group ",
                    deviceName: 'Device Group name',
                    delete: 'Delete',
                    confirm: 'Confirm',
                    cancel: 'Cancel',
                    inputRule: 'Please enter the device name',
                    inputGroupRule: 'Please enter the device group name',
                    deleteNoMsg: 'This device group is not associated with a device, are you sure to delete it?',
                    deleteMsg: 'Are you sure to delete this device group?'
                },
                zh: {
                    editNewDevice: "编辑设备组",
                    createNewDevice: "新建设备组",
                    deviceName: '设备组名称',
                    delete: '删除',
                    confirm: '确定',
                    cancel: '取消',
                    inputRule: '请输入设备名称',
                    inputGroupRule: '请输入设备组名称',
                    deleteNoMsg: '该设备组还未关联设备，确定删除吗？',
                    deleteMsg: '确定删除该设备组吗？'
                }
            }
        }
    })
], default_1);
export default default_1;
